import { useEffect, useState } from "react";
import useAppHooks from "../../../../../../shared/hooks/useAppHooks";
import RenderMathQuestion from "../../../../../../shared/components/RenderMathQuestion/RenderMathQuestion";
import { optionLables } from "../..";
import "./QuestionCard.css";
import Modal from "../../../../../../shared/components/Modal/Modal";
import QuestionHeader from "../../Layout/QuestionHeader/QuestionHeader";
import { updateQuestionStatus, saveAnswerRequest, setLastActionType } from "../../../../../../redux/exam/examSlice";
import { useSelector } from "react-redux";
// import { useSelector } from "react-redux";
const QuestionCard = () => {
  const { selector, dispatch } = useAppHooks();
  const state = selector((state) => state.examSlice);
  // const [hideStreakMessage, setHideStreakMessage] = useState(false);  // ⭐ add here




  const {
    questionsData,
    currentQuestionIndex,
    loading,
    testDetails,
    plannerDetails,
    paperId,
    selectedSetId,
    timeLeft,
    paper_duration,
    practiceStreak,
    optionId
  } = useSelector((state) => state.examSlice);


  const [integerAnswer, setIntegerAnswer] = useState("");
  // const [showIntegerModal, setShowIntegerModal] = useState(false);
  const [showIntegerModal, setShowIntegerModal] = useState(false);
  const [tempIntegerAnswer, setTempIntegerAnswer] = useState("");

  const [showCorrectAnswer, setShowCorrectAnswer] = useState(false);
  const [correctAnswer, setCorrectAnswer] = useState("");

  const currentLang = state?.currentLang || "en";
  const question = state?.question?.[0];
  // Check if we are in gamified practice mode (instant feedback)
  const isPracticeGamified =
    state?.testDetails?.practiceMode === "practice" &&
    state?.testDetails?.gamificationOn === true;
  // console.log("Question object:", question);

  // Mark current question as active/current
  useEffect(() => {
    if (question?.qid) {
      dispatch(
        updateQuestionStatus({
          qid: question.qid,
          makeCurrent: true,
        })
      );
    }
  }, [dispatch, question?.qid]);

  useEffect(() => {
    setShowCorrectAnswer(false);
  }, [question?.qid]);


  if (!question) {
    return null;
  }

  const handleOptionClick = (optionId) => {
    const currentQid = question.qid;
    const answerType = Number(question?.answer_type_id);

    const setId = question?.set_id ?? testDetails?.setId ?? null;
    const isTopicWise = !!setId;

    // 🔥 show streak
    // dispatch(setHideStreakMessage(false));

    dispatch(setLastActionType("OPTION_CLICK"));

    // SINGLE CORRECT
    if (answerType !== 2) {

      dispatch(
        updateQuestionStatus({
          qid: currentQid,
          selectedOption: optionId,
        })
      );


      if (isPracticeGamified) {
        dispatch(
          saveAnswerRequest({
            qid: question.qid,
            paper_type: testDetails?.paperType,
            option_id: optionId,
            time: question?.time_taken ?? 0,
            paper_id: isTopicWise ? null : question.paper_id,
            test_id: isTopicWise ? null : testDetails?.testId,
            set_id: isTopicWise ? setId : null,
            moveNext: false
          })
        );
      }
    }

    // MULTIPLE CORRECT
    else {
      const existingSelections = Array.isArray(currentQ.selectedOption)
        ? currentQ.selectedOption
        : [];

      const updatedSelections = existingSelections.includes(optionId)
        ? existingSelections.filter((id) => id !== optionId)
        : [...existingSelections, optionId];

      dispatch(
        updateQuestionStatus({
          qid: currentQid,
          selectedOption: updatedSelections,
        })
      );
    }
  };




  const handleIntegerInputChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setIntegerAnswer(value);
      dispatch(
        updateQuestionStatus({
          qid: question.qid,
          integerAnswer: value,
        })
      );
    }
  };

  const handleCheckAnswer = () => {
    const setId = question?.set_id ?? testDetails?.setId ?? null;
    const isTopicWise = !!setId;

    dispatch(setLastActionType("OPTION_CLICK"));



    // update local state immediately
    setIntegerAnswer(tempIntegerAnswer);

    // store user answer in Redux
    dispatch(
      updateQuestionStatus({
        qid: question.qid,
        integerAnswer: tempIntegerAnswer,
      })
    );

    // trigger single save API
    if (isPracticeGamified) {
      dispatch(
        saveAnswerRequest({
          qid: question.qid,
          paper_type: testDetails?.paperType,
          option_id: null,
          integer_answer: tempIntegerAnswer,
          time: question?.time_taken ?? 0,
          paper_id: isTopicWise ? null : question.paper_id,
          test_id: isTopicWise ? null : testDetails?.testId,
          set_id: isTopicWise ? setId : null,
          moveNext: false
        })
      );
    }

    const correct =
      question?.answer ??
      question?.correct_answer ??
      question?.correct_int ??
      "";

    setCorrectAnswer(String(correct));
    setShowCorrectAnswer(true);

    setShowIntegerModal(false);
  };

  const currentQ =
    state.questionsData?.find(
      (q) => q.qid === question?.qid
    ) || {};
  let optionsArray = [];

  if (Array.isArray(question?.option) && question.option.length > 0) {
    optionsArray = question.option;
  } else {
    const rawOption =
      currentLang === "en"
        ? question?.eng_option
        : question?.h_option;

    if (rawOption) {
      try {
        optionsArray = JSON.parse(rawOption);
      } catch (e) {
        console.log("Option parse error", e);
        optionsArray = [];
      }
    }
  }
  return (
    <div className="exam__question_card">
      <QuestionHeader />

      {/* Question */}
      <div className="exam__question_card__question">
        {question && (
          <RenderMathQuestion
            question={
              currentLang === "en"
                ? question.q_text
                : question.q_text_hindi
            }
          />
        )}
      </div>

      {/* Options / Integer Input */}
      <div className="exam__question_card__options">
        {[1, 2].includes(Number(question?.answer_type_id)) ? (
          optionsArray.map((opt, index) => {
            const isMultiple = Number(question?.answer_type_id) === 2;

            const isSelected = isMultiple
              ? Array.isArray(currentQ.selectedOption) &&
              currentQ.selectedOption.includes(opt.option_id)
              : currentQ.selectedOption === opt.option_id;

            const isCorrectOption = opt.is_correct === 1;

            const showResult =
              isPracticeGamified &&
              (isMultiple
                ? Array.isArray(currentQ.selectedOption) &&
                currentQ.selectedOption.length > 0
                : currentQ.selectedOption);

            let optionClass = "";
            let labelClass = "";

            if (showResult) {
              if (isSelected && isCorrectOption) {
                optionClass = "option-correct";
                labelClass = "label-correct";
              } else if (isSelected && !isCorrectOption) {
                optionClass = "option-wrong";
                labelClass = "label-wrong";
              } else if (!isSelected && isCorrectOption) {
                optionClass = "option-correct";
                labelClass = "label-correct";
              }
            } else if (isSelected) {
              optionClass = "selected";
              labelClass = "selected-label";
            }

            return (
              <div
                key={opt.option_id}
                className={`exam__question_card__option ${optionClass}`}
                onClick={() => handleOptionClick(opt.option_id)}
                style={{ pointerEvents: currentQ?.selectedOption ? "none" : "auto" }}
              >
                <span
                  className={`exam__question_card__option_label ${labelClass || "not-selected-label"
                    }`}
                >
                  {optionLables[index]}
                </span>

                <RenderMathQuestion
                  question={
                    currentLang === "en"
                      ? opt.option
                      : opt.option_hindi ?? opt.option
                  }
                />
              </div>
            );
          })
        ) : Number(question?.answer_type_id) === 3 ? (
          <div className="exam__question_card__integer_input">

            {/* User Answer */}
            <input
              type="text"
              value={integerAnswer || currentQ?.integerAnswer || ""}
              placeholder="Enter integer answer"
              readOnly={isPracticeGamified}
              onChange={(e) => {
                if (!isPracticeGamified) {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    setIntegerAnswer(value);

                    dispatch(
                      updateQuestionStatus({
                        qid: question.qid,
                        integerAnswer: value,
                      })
                    );
                  }
                }
              }}
              onClick={() => {
                if (isPracticeGamified) {
                  setTempIntegerAnswer(integerAnswer || currentQ?.integerAnswer || "");
                  setShowIntegerModal(true);
                }
              }}
            />

            {/* Correct Answer */}
            {showCorrectAnswer && (
              <input
                type="text"
                value={correctAnswer}
                readOnly
                className="correct-answer-input"
              />
            )}
          </div>
        ) : null}
      </div>

      {/* INTEGER ANSWER MODAL */}
      <Modal
        isOpen={showIntegerModal}
        onClose={() => setShowIntegerModal(false)}
        width="420px"
        height="220px"
      >
        <div className="integer-modal-container">
          <h3 className="integer-modal-title">
            Enter Your Answer (Integer Type)
          </h3>

          <input
            className="integer-modal-input"
            type="text"
            value={tempIntegerAnswer}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value)) {
                setTempIntegerAnswer(value);
              }
            }}
          />

          <div className="integer-modal-buttons">
            <button
              className="integer-cancel-btn"
              onClick={() => setShowIntegerModal(false)}
            >
              Cancel
            </button>

            <button
              className="integer-check-btn"
              onClick={handleCheckAnswer}
            >
              Check Answer
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default QuestionCard;